export class Tenant {
  public id?: string;
  public name: string;
  public email: string;
  public modules: any[];
}
